import { affiliateID, siteOptions } from '../../../common/commonRequests';
import { COST_TYPES } from '../../../common/dropdownConstants';

export const filters = () => ({
  site: {
    name: 'site',
    type: 'select',
    label: 'Vertical',
    options: () => siteOptions(),
    value: '2',
    inputWidth: 3
  },
  affiliateID: {
    name: 'affiliateID',
    type: 'autocomplete',
    label: 'Affiliate',
    options: () => affiliateID(),
    value: 'none',
    inputWidth: 3
  },
  costType: {
    name: 'costType',
    type: 'select',
    label: 'Cost Type',
    options: () => COST_TYPES,
    value: '2',
    inputWidth: 3
  }
});
